import tables from 'oderon-commons/src/tables.js'
import { translateType } from '@/models/client-history.js'

export const defCodes = ['id', 'timestamp', 'type', 'login', 'org', 'vehicle']

export const fullSpec = tables.preProcessSpec({
  defCodes,
  defaultSortable: false,
  columns: [
    {
      code: 'id',
      t: 'ID|',
      d: 'id',
      w: 100,
      color: '#cccccc'
    },

    {
      code: 'timestamp',
      t: 'Data/hora|',
      d: 'timestamp',
      selectable: false,
      w: 200,
      dataType: 'date',
      format: 'DD/MM/YYYY HH:mm'
    },

    {
      code: 'type',
      t: '|Tipo',
      d: (row) => translateType(row),
      selectable: false
    },

    {
      code: 'login',
      t: '|Login',
      d: 'login',
      selectable: false
    },
    {
      code: 'org',
      t: '|Org',
      d: 'vehicle.org.label',
      selectable: false
    },
    {
      code: 'vehicle',
      t: 'Veículo|',
      d: 'vehicle.code',
      selectable: false
    },

    {
      code: 'fromDepot',
      t: '|Estoque (saída)',
      d: 'fromDepot.name',
      selectable: true
    },
    {
      code: 'toDepot',
      t: '|Estoque (chegada)',
      d: 'toDepot.name',
      selectable: true
    },

    {
      code: 'costCenter',
      t: '|Centro de Custo',
      d: 'costCenter.name',
      selectable: true
    },
    {
      code: 'orgValue',
      t: '|Valor para a Org',
      d: 'costCenterValue',
      selectable: true,
      format: 'BRL'
    },
    {
      code: 'techValue',
      t: '|Valor para o Técnico',
      d: 'techValue',
      selectable: true,
      format: 'BRL'
    },

    {
      code: 'technician',
      t: '|Técnico',
      d: 'technician.name',
      selectable: true
    },

    {
      code: 'fwVersion',
      t: '|FW',
      d: 'firmware.version',
      selectable: true,
      f: (x) => `0x${(x || 0).toString(16)}`
    },

    {
      code: 'comments',
      t: '|Comentários',
      d: 'comments',
      selectable: true
    },
    {
      code: 'originVehicleCode',
      t: '|Placa Original',
      d: 'originVehicleCode',
      hint: 'Placa (digitada) do veículo no registro, antes da migração',
      selectable: true,
      group: 'debug'
    },
    {
      code: 'originOrg',
      t: '|Org Original',
      d: 'org.label',
      hint: 'Org do registro, antes da migração',
      selectable: true,
      group: 'debug'
    },
    {
      code: 'createdAt',
      t: '|Criado em',
      d: 'createdAt',
      selectable: true,
      dataType: 'date',
      format: 'DD/MM/YYYY HH:mm'
    },
    {
      code: 'updatedAt',
      t: '|Atualizado em',
      d: 'updatedAt',
      selectable: true,
      dataType: 'date',
      format: 'DD/MM/YYYY HH:mm'
    }
  ],
  rowStyleFn: ({ row }) => {
    if (row.deletedAt != null) {
      return { color: '#cccccc' }
    }
  },
  rowExtraFieldsFn: ({ extraFields, row }) => {
    extraFields.historyType = row.type
    extraFields.historySubType = row.subType
    extraFields.clientId = row.clientId
  }
})
